import script from "./highXB.vue?vue&type=script&setup=true&lang=js"
export * from "./highXB.vue?vue&type=script&setup=true&lang=js"

import "./highXB.vue?vue&type=style&index=0&id=42a0fd1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a0fd1a"]])

export default __exports__